export const TENANT_CONTEXT_RENEW_BEFORE_MS = 30_000;

export type TenantContextIntent = 'manual' | 'renewal';

export interface TenantContextRequest {
  generation: number;
  intent: TenantContextIntent;
}

/** Latest-wins coordinator for act-as token requests. Manual selection/clear
 * invalidates every older request; automatic renewal waits while a manual
 * intent is unresolved so it cannot restore the previous tenant. */
export function createTenantContextIntentCoordinator() {
  let generation = 0;
  let pendingManualGeneration: number | undefined;

  return {
    begin(intent: TenantContextIntent): TenantContextRequest | undefined {
      if (intent === 'renewal' && pendingManualGeneration !== undefined) return undefined;
      generation += 1;
      if (intent === 'manual') pendingManualGeneration = generation;
      return { generation, intent };
    },
    isCurrent(request: TenantContextRequest): boolean {
      return request.generation === generation;
    },
    finish(request: TenantContextRequest): void {
      if (request.intent === 'manual' && pendingManualGeneration === request.generation) {
        pendingManualGeneration = undefined;
      }
    },
  };
}

export function tenantContextRenewalDelayMs(expiresAt: string, now = Date.now()): number {
  const expiresAtMs = Date.parse(expiresAt);
  if (!Number.isFinite(expiresAtMs)) return 0;
  return Math.max(expiresAtMs - now - TENANT_CONTEXT_RENEW_BEFORE_MS, 0);
}
